<template>
  <b-input-group-text>{{ label }}<span class="text-danger">*</span>:</b-input-group-text>
</template>
<script>

export default {
  props: ['label'],
  name: 'c-required-label'
}
</script>
